import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleResponsiveCarouselModule } from './simple-responsive-carousel/simple-responsive-carousel.module';
import { SimpleResponsiveBannerModule } from './simple-responsive-banner/simple-responsive-banner.module';
import { GridCategoriesModule } from './grid-categories/grid-categories.module';
import { PDFViewerModule } from './pdf-viewer/pdf-viewer.module';
import { IframeModule } from './iframe/iframe.module';
import { CustomHamburguerMenuModule } from '../hamburguer-menu/hamburguer-menu.module';
import { CustomProductCarouselModule } from './product/product-carousel/product-carousel.module';
import { BannerListModule } from './grid-banners/grid-banners.module';
import { CustomMediaModule } from '../media/media.module';
import { PlpNoContentModule } from '../../../product/product-list/plp-no-content/plp-no-content.module';
import { VideoBannerModule } from './video-banner/video-banner.module';
import { TextAndImageModule } from './text-and-image/text-and-image.module';
import { ContentPageGridModule } from './content-page-grid/content-page-grid.module';
import { CustomCmsParagraphModule } from './paragraph/paragraph.module';
import { TabContainerModule } from './tab-container/tab-container.module';
import { CmsCollapseContainerModule } from './collapse-container/cms-collapse-container.module';
import { CmsCustomBreadcrumbModule } from './cms-custom-breadcrumb/cms-custom-breadcrumb.module';
import { PageGridContainerModule } from './page-grid-container/page-grid-container.module';
import { CmsAbstractGridModule } from './cms-abstract-grid/cms-abstract-grid.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SimpleResponsiveCarouselModule,
    SimpleResponsiveBannerModule,
    GridCategoriesModule,
    PDFViewerModule,
    IframeModule,
    CustomHamburguerMenuModule,
    CustomProductCarouselModule,
    BannerListModule,
    CustomMediaModule,
    PlpNoContentModule,
    VideoBannerModule,
    TextAndImageModule,
    ContentPageGridModule,
    CustomCmsParagraphModule,
    TabContainerModule,
    CmsCollapseContainerModule,
    CmsCustomBreadcrumbModule,
    CmsAbstractGridModule,
    PageGridContainerModule,
  ],
})
export class CmsComponentsModule {}
